import { Component, inject } from '@angular/core'
import { AssetProfileService } from '@ziptility/feature/asset-profile.service'
import { NotificationListComponent } from '@ziptility/notifications/notification-list.component'

@Component({
    selector: 'feature-history',
    template: `
    <div class="p-5">
      <notification-list [dataSource]="vm.featureHistory"></notification-list>
    </div>
  `,
    imports: [NotificationListComponent]
})
export class FeatureHistoryComponent {
  readonly vm = inject(AssetProfileService)
}
